import Footer from "./Footer";
import Header from "./Header";
import TopToScrollBar from "./TopToScrollBar";
// import header
import { useAuth0 } from "@auth0/auth0-react";
import { useCheckCookie } from "../hooks/useCkeckCookie";
import Classes from "./style/LoadingEffect.module.css";
export default function Layout({ children }) {
  const { isLoading } = useAuth0();
  const { go } = useCheckCookie();
  if (isLoading) {
  return (
    <main className="mainClass" style={{ marginTop: "6rem" }}>
      <div className={Classes.main_div}>
        <div className={Classes.center_div}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </main>
  );
  }
  return (
    <main className="mainClass" style={{ marginTop: "6rem" }}>
      <div className="forFixFooter">
        {go && <Header />}
        {go && children}
        <TopToScrollBar />
        <Footer />
      </div>
    </main>
  );
}
